
const META_PIXEL_ID = '2782582688765590'

interface MetaPixelWindow extends Window {
  fbq?: {
    (...args: unknown[]): void
    callMethod?: (...args: unknown[]) => void
    queue?: unknown[]
    push?: (...args: unknown[]) => void
    loaded?: boolean
    version?: string
  }
  __pilatesResueltoPageViewSent?: boolean
}

export function trackMetaPageView() {
  if (typeof window === 'undefined') return

  const pixelWindow = window as MetaPixelWindow
  if (pixelWindow.__pilatesResueltoPageViewSent) return

  if (!pixelWindow.fbq) {
    const fbq: NonNullable<MetaPixelWindow['fbq']> = function (...args: unknown[]) {
      if (fbq.callMethod) {
        fbq.callMethod(...args)
      } else {
        fbq.queue?.push(args)
      }
    }

    fbq.queue = []
    fbq.loaded = true
    fbq.version = '2.0'
    pixelWindow.fbq = fbq

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  pixelWindow.fbq('init', META_PIXEL_ID)
  pixelWindow.fbq('track', 'PageView')
  pixelWindow.__pilatesResueltoPageViewSent = true
}

